"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestSBMultipleCustomBetQuotation = requestSBMultipleCustomBetQuotation;
async function requestSBMultipleCustomBetQuotation(params) {
    const request = {
        header: this.header,
        sessionToken: this.sessionToken,
        currency: this.controllerDefaults.currency,
        integrationPartnerId: this.controllerDefaults.integrationPartnerId,
        language: this.controllerDefaults.language,
        ...params,
    };
    return (await this.sendRequest('requestSBMultipleCustomBetQuotation.ashx', request));
}
